import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { CloseLight, Action } from 'esa-ui-library';
import { PropertyType, useStore } from '../../../../../common';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

const VipLevelsFilter = (): JSX.Element => {
	const [{ player_levels, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions);

		onFilter([{ name: 'vip_levels', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'vip_levels', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (player_levels) {
			setFiltersOptions(cloneDeep(player_levels));
		}
	}, [player_levels]);

	useEffect(() => {
		const filter = find(filters, ['name', 'vip_levels'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(player_levels, filter));
	}, [filters]);

	return (
		<div>
			<Action
				label='Vip Levels'
				labelContent={getLabelContent()}
				select
				className={`${filtersStyles.Filter} 
				${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
				dataId='viplevels-filter'
			>
				<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
			</Action>
		</div>
	);
};

export { VipLevelsFilter };
